import ApplicationSerializer from 'eflex/serializers/application';

export default class ProductionScheduleSerializer extends ApplicationSerializer {
  attrs = {
    passed: {
      serialize: false,
    },
    failed: {
      serialize: false,
    },
  };
}
